const fileToBeTransferred = 'partisan.txt';
const restrictedFolder = 'blackhat';
const adminFolder = 'thecoup';
const directoryTree = ['begin', 'guest', 'loginuser', 'thecoup', 'blackhat'];

export { fileToBeTransferred, restrictedFolder, adminFolder, directoryTree };
